// Helpers puros de MapHelper (filtrado de métricas por año y redondeo).
// Extraídos para poder testear la lógica sin renderizar Leaflet/el mapa.

// Filtra las métricas por el año seleccionado y redondea su valor a 2 decimales.
export const filterAndRoundByYear = <T extends { year: string | number; value: number }>(
  metrics: T[],
  yearName: string | number,
): T[] =>
  metrics
    .filter(it => it.year === yearName)
    .map(it => ({ ...it, value: Math.round(it.value * 100) / 100 }))